import { useNavigate } from "react-router-dom";
import {
  RiMailLine,
  RiMessage2Line,
  RiWhatsappLine,
  RiFileUploadLine,
  RiRobot2Line,
  RiPieChartLine,
  RiHistoryLine,
  RiSettings4Line,
  RiFileTextLine,
  RiMoneyDollarCircleLine,
  RiFlashlightLine,
} from "react-icons/ri";
// import QuickActions from '../components/dashboard/QuickActions'
import RecentActivity from "../components/dashboard/RecentActivity";

const Dashboard = () => {
  const navigate = useNavigate();

  const marketingTools = [
    {
      id: "quick-actions",
      name: "Quick Actions",
      description: "Access frequently used features and shortcuts",
      icon: RiFlashlightLine,
      path: "/actions",
      color: "from-amber-500 to-orange-500",
      stats: "Fast Access",
    },
    {
      id: "data-upload",
      name: "Data Upload",
      description: "Import contacts and data from files",
      icon: RiFileUploadLine,
      path: "/data-upload",
      color: "from-purple-500 to-indigo-500",
      stats: "Bulk Import",
    },
    {
      id: "email",
      name: "Email Templates",
      description: "Create and manage email templates with AI assistance",
      icon: RiMailLine,
      path: "/email-templates",
      color: "from-blue-500 to-cyan-500",
      stats: "150+ Templates",
    },
    {
      id: "bulk-messaging",
      name: "Bulk Messaging",
      description: "Send messages via Email, SMS, and WhatsApp",
      icon: RiMessage2Line,
      path: "/bulk-messaging",
      color: "from-green-500 to-emerald-500",
      stats: "Multi-channel",
    },
    {
      id: "ai-followups",
      name: "AI Follow-ups",
      description: "Automate follow-ups with AI assistance",
      icon: RiRobot2Line,
      path: "/ai-followups",
      color: "from-pink-500 to-rose-500",
      stats: "Smart Automation",
    },
    {
      id: "analytics",
      name: "Analytics",
      description: "Track performance and engagement metrics",
      icon: RiPieChartLine,
      path: "/analytics",
      color: "from-amber-500 to-orange-500",
      stats: "Real-time Data",
    },
    {
      id: "message-history",
      name: "Message History",
      description: "View and manage sent messages",
      icon: RiHistoryLine,
      path: "/message-history",
      color: "from-teal-500 to-cyan-500",
      stats: "Message Tracking",
    },
    {
      id: "automation",
      name: "Automation",
      description: "Set up automated workflows and rules",
      icon: RiSettings4Line,
      path: "/automation",
      color: "from-violet-500 to-purple-500",
      stats: "Smart Rules",
    },
  ];

  const invoicingTools = [
    {
      id: "billing",
      name: "Billing & Invoices",
      description: "Create and manage invoices, collect payments",
      icon: RiFileTextLine,
      path: "/billing",
      color: "from-violet-500 to-purple-500",
      stats: "Invoice Management",
    },
    {
      id: "create-invoice",
      name: "Create Invoice",
      description: "Generate professional invoices for your clients",
      icon: RiFileTextLine,
      path: "/create-invoice",
      color: "from-violet-500 to-purple-500",
      stats: "Quick Generate",
    },
    {
      id: "payment-gateway",
      name: "Payment Collection",
      description: "Collect payments through multiple payment gateways",
      icon: RiMoneyDollarCircleLine,
      path: "/payments",
      color: "from-yellow-500 to-orange-500",
      stats: "Secure Payments",
    },
    {
      id: "invoice-history",
      name: "Invoice History",
      description: "View and manage all your invoices",
      icon: RiHistoryLine,
      path: "/invoice-history",
      color: "from-teal-500 to-cyan-500",
      stats: "Track Invoices",
    },
  ];

  const renderToolSection = (tools, title) => (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-secondary-900">{title}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {tools.map((tool) => (
          <div
            key={tool.id}
            className="card group cursor-pointer hover:shadow-lg"
            onClick={() => navigate(tool.path)}
          >
            <div className="flex items-start space-x-4">
              <div
                className={`p-4 rounded-xl bg-gradient-to-br ${tool.color} text-white`}
              >
                <tool.icon className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-secondary-900 group-hover:text-primary-600">
                  {tool.name}
                </h3>
                <p className="text-secondary-600 mt-1">{tool.description}</p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-sm text-secondary-500">
                    {tool.stats}
                  </span>
                  <span className="text-primary-600 text-sm font-medium group-hover:underline">
                    Open →
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-secondary-900">
          Welcome to Invoicify,
        </h1>
        <p className="mt-2 text-secondary-600">
          Manage your marketing and invoicing in one place
        </p>
      </div>
      {renderToolSection(invoicingTools, "Invoicing & Payments")}
      {renderToolSection(marketingTools, "Marketing Tools")}

      <section>
        <RecentActivity />
      </section>

      <div className="card bg-gradient-to-br from-primary-50 to-primary-100/50 border-2 border-dashed border-primary-200">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-primary-900">
              Need Help Getting Started?
            </h2>
            <p className="mt-1 text-primary-700">
              Check out our quick start guide and tutorials
            </p>
          </div>
          <button
            className="btn btn-primary"
            onClick={() => {
              /* Help documentation link */
            }}
          >
            View Guide
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
